<template xmlns:v-linkified="http://www.w3.org/1999/xhtml">
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> Policies & Forms
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="locationId"
                                          name="locationId"
                                          id="locationData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationArr"
                                          placeholder="Select State">
                                </v-select>
                            </div>
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select class=""
                                          v-model="roleId"
                                          name="roleId"
                                          id="roleData"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="roleArr"
                                          placeholder="Select Role">
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="col-12 float-l width-full">
            <div class="container">
                <div class="row">
                    <div class="forms-policy-main-section col-12 float-l">
                        <div class="row">

                            <!--Dynamic Content-->
                            <template v-for="(text, index) in policiesFormsList">
                                <div class="forms-detail-main col-12 float-l"> <!--forth policy-->
                                    <!--<div class="row">-->
                                    <div class="">
                                        <template v-if="(index + 1) % 2 == 0">
                                            <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                                <img :src="text.image_path" />
                                            </div>
                                        </template>
                                        <template v-if="(index + 1) % 2 != 0">
                                            <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                                <img :src="text.image_path" />
                                            </div>
                                        </template>

                                        <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                            <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> {{text.title}} </h2>
                                            <!--<p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30"> {{text.description}} <a class="internal-link" href="https://usr54.dayforcehcm.com/CandidatePortal/en-US/LATruck" target="_blank"> Go to Dayforce  </a> </p>-->
                                            <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30" v-html="text.description" v-linkified:options="{ className: 'internal-link' }" v-linkified></p>
                                            <!--<p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30"> Please contact Human Resources at <a class="internal-link" href="mailto:hr@vvgtruck.com" target="_blank"> hr@vvgtruck.com </a> </p>-->
                                            <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30" v-html="text.contact_description" v-linkified:options="{ className: 'internal-link' }" v-linkified></p>
                                            <div class="benefit-links-section-left-1 col-12">
                                                <div class="row">
                                                    <template v-for="(btn, index) in text.button_array">
                                                        <p>
                                                            <template v-if="btn.button_document != ''">
                                                                <!-- <a :href="btn.button_document" target="_blank" class="hvr-sweep-to-right-blue"> -->
                                                                <a href="#" :id="'id' + index" @click="getSignedUrlPath(btn.button_document)" class="hvr-sweep-to-right-blue">
                                                                    {{btn.button_title}}
                                                                </a>
                                                            </template>
                                                            <template v-if="btn.button_url != ''">
                                                                <a :href="btn.button_url" target="_blank" class="hvr-sweep-to-right-blue">
                                                                    {{btn.button_title}}
                                                                </a>
                                                            </template>
                                                        </p>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!--End Dynamic Content-->

                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;twelve policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                        <img src="/static/images/policies.jpg" alt="Policies">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Policies </h2>
                                        &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/phone_recording_authorization.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Phone Recording Authorization Form
                                                    </a> </p>
                                            </div>
                                        </div>&ndash;&gt;
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/TECHNICIAN_TRAINING_POLICY_revised.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Technician Training Policy
                                                </a> </p>
                                            </div>
                                        </div>
                                        &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Weight Room Agreement.doc" target="_blank" class="hvr-sweep-to-right-blue"> Weight Room Agreement
                                                    </a> </p>
                                            </div>
                                        </div>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/video_surveillance_policy.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Video Surveillance Policy
                                                    </a> </p>
                                            </div>
                                        </div>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/VVG Photo Release.DOC" target="_blank" class="hvr-sweep-to-right-blue"> Photo Release / Facebook
                                                    </a> </p>
                                            </div>
                                        </div>&ndash;&gt;
                                    </div>
                                </div>
                            </div>-->


                            <!--twelve policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> 
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                        <img src="/static/images/webinars.jpg" alt="Webinar">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Webinar & Zoom Library </h2>
                                        <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont"> Stay tuned... past webinars will be posted here. </p>
                                    </div>
                                </div>
                            </div>--> <!--first policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;second policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                        <img src="/static/images/performance-management.jpg" alt="Performance management">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Performance management </h2>
                                        &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/employee_discipinary_report.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Employee Disciplinary Report </a> </p>
                                            </div>
                                        </div>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/employee_disciplinary_report_with_corrective_action.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Employee disciplinary report with Corrective Action </a> </p>
                                            </div>
                                        </div>&ndash;&gt;
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Performance Improvement Plan template 2015 (2).doc" target="_blank" class="hvr-sweep-to-right-blue"> Performance Improvement Plan </a> </p>
                                            </div>
                                        </div>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/performance_evaluation_form_no3.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Performance Evaluation Form </a> </p>
                                            </div>
                                        </div>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                &lt;!&ndash;<p> <a href="/static/pdf/Perf Assessment Development Form MANAGER.doc" target="_blank" class="hvr-sweep-to-right-blue"> Manager Performance Evaluation </a> </p>&ndash;&gt;
                                                <p> <a href="/static/pdf/Manager Performance Evaluation.doc" target="_blank" class="hvr-sweep-to-right-blue"> Manager Performance Evaluation </a> </p>
                                            </div>
                                        </div>
                                        &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Perf Assessment Development Form MANAGER.doc" target="_blank" class="hvr-sweep-to-right-blue"> Performance Assessment & Development Plan (management)</a> </p>
                                            </div>
                                        </div>&ndash;&gt;
                                    </div>
                                </div>
                            </div> --><!--second policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> 
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                        <div class="row">
                                            <img src="/static/images/job-descriptions.jpg" alt="Job Description">
                                        </div>
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <div class="row">
                                            <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Job Description </h2>
                                            <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont"> Stay tuned... a job description library for Service/Parts/Accounting/VTRL/Buswest & Crossroads etc. </p>
                                        </div>
                                    </div>
                                </div>
                            </div> <!--third policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;forth policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                        <img src="/static/images/recruitment.jpg" alt="Recruitment & On-boarding">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Recruitment & On-boarding </h2>
                                        <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30"> All recruiting is done through Dayforce. All job openings require a job requisition in Dayforce. <a class="internal-link" href="https://usr54.dayforcehcm.com/CandidatePortal/en-US/LATruck" target="_blank"> Go to Dayforce  </a> </p>
                                        <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30"> Please contact Human Resources at <a class="internal-link" href="mailto:hr@vvgtruck.com" target="_blank"> hr@vvgtruck.com </a> </p>
                                        <p class="heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30" v-html="rawData" v-linkified:options="{ className: 'internal-link' }" v-linkified></p>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/i-9-2017.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Forms: Download l-9
                                                </a> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--> <!--forth policy-->
                            <!-- <div class="forms-detail-main col-12 float-l"> &lt;!&ndash;fifth policy&ndash;&gt;
                                 <div class="row">
                                     <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                         <img class="mt-60" src="/static/images/payroll.jpg" alt="Payroll">
                                     </div>
                                     <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                         <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Payroll </h2>
                                         &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                             <div class="row">
                                                 <p> <a href="/static/pdf/final _technician_pay_plan.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Technician Pay Plan
                                                     </a> </p>
                                             </div>
                                         </div>&ndash;&gt;
                                         <div class="benefit-links-section-left-1 col-12">
                                             <div class="row">
                                                 <p> <a href="/static/pdf/VVG_loan_agreement.pdf" target="_blank" class="hvr-sweep-to-right-blue"> VVG Loan agreement
                                                 </a> </p>
                                             </div>
                                         </div>
                                         &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                             <div class="row">
                                                 <p> <a href="/static/pdf/dayforce_approval_process.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Dayforce Approval Process
                                                     </a> </p>
                                             </div>
                                         </div>&ndash;&gt;
                                         <div class="benefit-links-section-left-1 col-12">
                                             <div class="row">
                                                 <p> <a href="/static/pdf/bonus_request_form.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Bonus Request Form
                                                 </a> </p>
                                             </div>
                                         </div>
                                         <div class="benefit-links-section-left-1 col-12">
                                             <div class="row">
                                                 <p> <a href="/static/pdf/employee_status_change_form.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Employee Status Change Form
                                                 </a> </p>
                                             </div>
                                         </div>
                                     </div>
                                 </div>
                             </div> --><!--fifth policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;sixth policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                        <img src="/static/images/fmla.jpg" alt="Leave of Absence">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Leave of Absence </h2>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Dayforce 101- Leave Process.docx" target="_blank" class="hvr-sweep-to-right-blue"> Dayforce 101: Managing Leaves of Absence
                                                </a> </p>
                                            </div>
                                        </div>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Employee LOA Flyer.pdf" target="_blank" class="hvr-sweep-to-right-blue"> LOA Flyer for Employees </a> </p>
                                            </div>
                                        </div>
                                        <div id="myModal" class="modal fade">
                                            <div class="modal-dialog">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                                        <h4 class="modal-title">FMLA Manager Trainer video</h4>
                                                    </div>
                                                    <div class="modal-body">
                                                        &lt;!&ndash;<v-playback :name="'v_play'+text.id" :url="text.video" ></v-playback>&ndash;&gt;
                                                        <video width="560" controls>
                                                            <source src="/static/video/2018-11-08 16.00 FMLA - Manager Training.mp4" type="video/mp4">
                                                            Your browser does not support the video tag.
                                                        </video>
                                                        &lt;!&ndash;<iframe id="hrbenifit" width="560" height="315" :src="text.video" frameborder="0" allowfullscreen></iframe>&ndash;&gt;
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--> <!--sixth policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;seventh policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                        <img src="/static/images/termination.jpg" alt="Termination">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Separations </h2>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                &lt;!&ndash;<p> <a href="/static/pdf/seperation_form.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Separation Form (pdf)&ndash;&gt;
                                                <p> <a href="/static/pdf/Separations.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Separation Form (pdf)
                                                </a> </p>
                                            </div>
                                        </div>
                                        &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/notice_to_employees_as_to_change_in_relationship.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Notice To Employees As To Change In Relationship (pdf)
                                                    </a> </p>
                                            </div>
                                        </div>&ndash;&gt;
                                    </div>
                                </div>
                            </div>--> <!--seventh policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;eight policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                        <img src="/static/images/other.jpg" alt="Other/Misc.">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Other/Misc. </h2>
                                        &lt;!&ndash;                                        <div class="benefit-links-section-left-1 col-12">
                                                                                    <div class="row">
                                                                                        <p> <a href="/static/pdf/employee_status_change_form.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Employee Status Change Form
                                                                                            </a> </p>
                                                                                    </div>
                                                                                </div>&ndash;&gt;
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/personnel_records_request_form.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Personnel Records Request Form
                                                </a> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--> <!--eight policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;ninrth policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                        <img src="/static/images/investigation.jpg" alt="Investigation">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Investigation </h2>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/harassment_complaint_form.pdf" target="_blank" class="hvr-sweep-to-right-blue"> Harassment Complaint Form
                                                </a> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--> <!--nineth policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;tenth policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right">
                                        <img src="/static/images/sops.jpg" alt="Standard Operating Procedures (SOPs)">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Standard Operating Procedures (SOPs) </h2>
                                        &lt;!&ndash;<div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Dayforce 101- LOA Process.docx" target="_blank" class="hvr-sweep-to-right-blue"> Dayforce 101- LOA Process
                                                    </a> </p>
                                            </div>
                                        </div>&ndash;&gt;
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="/static/pdf/Dayforce 101- Pending Enrollments.docx" target="_blank" class="hvr-sweep-to-right-blue"> Dayforce 101- Pending Enrollments
                                                </a> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--> <!--tenth policy-->
                            <!--<div class="forms-detail-main col-12 float-l"> &lt;!&ndash;eleventh policy&ndash;&gt;
                                <div class="row">
                                    <div class="left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left">
                                        <img src="/static/images/workers-comp.jpg" alt="Worker's Compensation">
                                    </div>
                                    <div class="right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left">
                                        <h2 class="heading-text-20 line-height-22 color-red font-text-bold-mont ucase"> Worker's Compensation </h2>
                                        <div class="benefit-links-section-left-1 col-12">
                                            <div class="row">
                                                <p> <a href="https://www.velocityvehiclegroup.com/safety" target="_blank" class="hvr-sweep-to-right-blue"> Visit Safety Section
                                                </a> </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>--> <!--eleventh policy-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    import VueFrame from 'vue-frame';

    var self;
    export default {
        name: 'Forms_Policies',
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            'v-frame': VueFrame,
        },
        data() {
            return {
                FirstLoad: true,
                roleId: 0,
                roleArr: [],
                locationId: 0,
                locationArr: [],
                policiesFormsList: [],
                // rawData : 'Please contact Human Resources at hr@vvgtruck.com',
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            self.getBuildVersion();
        },
        mounted: function () {
            self.MenuClose();
            self.loadLocations();
            self.loadRole();
            self.getPermissions();
            self.getPoliciesFormsData();
        },
        watch: {
            locationId: function (locationId) {
                self.getPoliciesFormsData();
            },
            roleId: function (roleId) {
                self.getPoliciesFormsData();
            }
        },

        methods: {
            loadLocations() {
                HTTP.post("getlocation")
                        .then(function (response) {
                            self.locationArr = [];
                            /*var addAll = {text: 'All', value: '0'};
                             self.locationArr.push(addAll);*/
                            $.each(response.data.content, function (i) {
                                /*if (response.data.content[i].value != 0) {*/
                                self.locationArr.push(response.data.content[i]);
                                /*}*/
                            });
                            self.locationId = {text: response.data.content[0].text, value: response.data.content[0].value};
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            var addAll = {text: 'All', value: '0'};
                            //self.roleArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                            self.roleId = addAll;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            getPoliciesFormsData() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var roleId = (self.roleId === null || self.roleId == '') ? 0 : self.roleId.value;
                var locationId = (self.locationId === null || self.locationId == '') ? 0 : self.locationId.value;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        role_id: roleId,
                        location_id: locationId,
                    }
                };

                HTTP.post("getpoliciesformsdata", '', config)
                        .then(function (response) {
                            self.policiesFormsList = [];
                            setTimeout(function () {
                                self.policiesFormsList = response.data.content;
                            }, 100);
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/FormsPolicies.vue